import {PromocodeTicketsInterface} from "@/views/Admin/Events/Event/Promocodes/AttachedEvents/AttachedEvents.interface";

export const AttachedEventsSchema: PromocodeTicketsInterface  = {
    initialPromocodeEvent: null,
    relatedEvents: [],
    promocodeId: null,
}
